var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccx = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30.811,
  height: 36,
  x: 8.189,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M8.189 29h30.81v7a2 2 0 0 1-2 2H10.19a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M29.757 29V2H37a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 36.973,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#005871",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.83 17.61h1.2l2.72 7.14h-1.29l-.67-1.82H7.02l-.66 1.82H5.11zm1.63 4.31L8.4 18.98l-1.05 2.94zm8.735.42q-.06.56-.27 1.03t-.58.82a2.7 2.7 0 0 1-.9.55 3.6 3.6 0 0 1-1.23.19q-.77 0-1.38-.26a2.8 2.8 0 0 1-1.02-.74 3.4 3.4 0 0 1-.63-1.18 5.4 5.4 0 0 1-.21-1.56q0-.88.23-1.58.24-.7.67-1.18a2.8 2.8 0 0 1 1.03-.74q.6-.26 1.32-.26.67 0 1.16.17t.83.49q.35.31.55.75.21.44.31.98l-1.19.17a3.6 3.6 0 0 0-.2-.64 1.4 1.4 0 0 0-.32-.47 1.2 1.2 0 0 0-.47-.3 1.8 1.8 0 0 0-.67-.11q-.48 0-.85.19a1.8 1.8 0 0 0-.63.55 2.6 2.6 0 0 0-.38.85 4.4 4.4 0 0 0-.13 1.12q0 .63.13 1.13a2.7 2.7 0 0 0 .4.86q.26.35.62.54.37.18.84.18.42 0 .71-.11.3-.11.5-.31c.2-.2.237-.293.31-.48q.12-.29.17-.65zm7.12 0q-.06.56-.27 1.03t-.58.82a2.7 2.7 0 0 1-.9.55q-.531.19-1.23.19a3.5 3.5 0 0 1-1.38-.26 2.8 2.8 0 0 1-1.02-.74 3.5 3.5 0 0 1-.63-1.18 5.4 5.4 0 0 1-.21-1.56q0-.88.23-1.58.24-.7.67-1.18.43-.49 1.03-.74.6-.26 1.32-.26.67 0 1.16.17t.83.49q.35.31.55.75.21.44.31.98l-1.19.17a3.6 3.6 0 0 0-.2-.64 1.4 1.4 0 0 0-.32-.47 1.2 1.2 0 0 0-.47-.3 1.8 1.8 0 0 0-.67-.11q-.48 0-.85.19a1.8 1.8 0 0 0-.63.55 2.6 2.6 0 0 0-.38.85 4.4 4.4 0 0 0-.13 1.12q0 .63.13 1.13.14.5.4.86.26.35.62.54.369.18.84.18.42 0 .71-.11.3-.11.5-.31t.31-.48q.12-.29.17-.65zm2.773-1.36-2.32-3.37h1.38l1.64 2.5 1.66-2.5h1.3l-2.3 3.42 2.58 3.72h-1.39l-1.9-2.82-1.84 2.82h-1.31z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccx);
export default ForwardRef;